const SECTION_SELECTORS = [
  ['#get-purchase-option-by-date-student-', 'uniqueOfferIdentifier'],
  ['#purchase-option-price-section-student-', 'uniqueOfferIdentifier'],
  ['#add-to-cart-student-', 'uniqueOfferIdentifier'],
  ['#get-purchase-option-by-date-instructor-', 'isbn13'],
  ['#purchase-option-price-section-instructor-', 'isbn13'],
  ['#add-to-cart-instructor-', 'isbn13'],
];

function showSections(option, onLoad) {
  option
    .querySelectorAll('mhecomm-add-to-cart, mhecomm-date-label, .purchase-option-price-section')
    .forEach((section) => {
      const campaign = JSON.parse((section.dataset.googleCampaignId || 'false').toLowerCase());
      if (
        !onLoad ||
        !campaign ||
        (section.dataset.requestedIsbn === section.dataset.purchaseOptionIsbn13 &&
          section.hasAttribute('data-google-campaign-master'))
      ) {
        section.classList.remove('d-none');
      }
    });
}

function toggleSections(radio, show) {
  const options = radio.closest(`#${radio.dataset.purchaseOptionsId}`);
  SECTION_SELECTORS.forEach(([selector, key]) => {
    const section = options?.querySelector(selector + radio.dataset[key]);
    if (section) {
      section.classList.toggle('d-none', !show);
      if (!show) section.classList.remove('d-block');
    }
  });
}

function selectRadio(radio) {
  const isbn = radio.closest('.po-content')?.querySelector('.isbnContainer');
  if (isbn) {
    isbn.id = `${radio.dataset.isbn13}-isbn`;
    const isbn10 = isbn.querySelector('.isbn');
    const isbn13 = isbn.querySelector('.isbn13');
    if (isbn10) isbn10.innerText = radio.dataset.isbn10;
    if (isbn13) isbn13.innerText = radio.dataset.isbn13;
  }
  toggleSections(radio, true);
}

function selectFirstRadio(option) {
  const radios = option.querySelectorAll('input[type="radio"]');
  if (!radios.length) return showSections(option, false);
  radios.forEach((radio, index) => {
    radio.checked = index === 0;
    if (index === 0) selectRadio(radio);
    else toggleSections(radio, false);
  });
}

function forEachOption(trigger, callback) {
  const target = trigger.dataset.bsTarget && document.querySelector(trigger.dataset.bsTarget);
  target?.querySelectorAll('.po-content').forEach(callback);
}

function selectMatchingRadios(clicked) {
  forEachOption(clicked, (option) => {
    const radios = option.querySelectorAll('input[type="radio"]');
    if (!radios.length) return showSections(option, false);
    radios.forEach((radio) => {
      const matches = radio.dataset.offerPricingId
        ? radio.dataset.offerPricingId === clicked.dataset.offerPricingId
        : radio.dataset.isbn13 === clicked.dataset.isbn13 || radio.dataset.isbn10 === clicked.dataset.isbn13;
      radio.checked = matches;
      if (matches) selectRadio(radio);
      else toggleSections(radio, false);
    });
  });
}

function loadSelectedTab() {
  const active = document.querySelector('.purchase-options-tabs .nav-tabs:not(.d-none) .nav-link.active');
  if (!active) return;
  forEachOption(active, (option) => {
    const radios = option.querySelectorAll('input[type="radio"]');
    if (!radios.length) return showSections(option, true);
    let found = false;
    radios.forEach((radio) => {
      const matches =
        (radio.dataset.isbn13 === radio.dataset.requestedIsbn ||
          radio.dataset.isbn10 === radio.dataset.requestedIsbn) &&
        !found;
      if (matches) {
        radio.checked = true;
        selectRadio(radio);
        found = true;
      } else {
        toggleSections(radio, false);
      }
    });
    if (!found) selectFirstRadio(option);
  });
}

export function initializePurchaseOptionIsbn(root = document) {
  if (!root.body?.classList.contains('mhecomm-he-pdp-page')) return;
  root.querySelectorAll('.mhecomm-purchase-options .nav-tabs .nav-link').forEach((tab) => {
    tab.addEventListener('click', () => forEachOption(tab, selectFirstRadio));
  });
  root
    .querySelectorAll('.mhecomm-purchase-options label, .mhecomm-purchase-options input[type="radio"]')
    .forEach((option) => {
      option.addEventListener('click', () => selectMatchingRadios(option));
    });
  document.addEventListener('studentInstructorToggleGroupChange', loadSelectedTab);
  loadSelectedTab();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializePurchaseOptionIsbn(), { once: true });
} else {
  initializePurchaseOptionIsbn();
}

window.addEventListener('pageshow', () => {
  if (document.body.classList.contains('mhecomm-he-pdp-page')) loadSelectedTab();
});
